import React, { FunctionComponent } from "react";
import { LinkButton } from "@bca/ui-library";
import getEnvironment from "../../helpers/getEnvironment";
import { Environments } from "../../types/environment.type";
import { useRouter } from "next/router";

const LOCAL_HOST_URL = "http://localhost:3000";

interface VersionNavigationButtonProps {
  isLatestVersion: boolean;
  soldDate: string;
  isMobileDevice: boolean;
}

const VersionNavigationButton: FunctionComponent<
  VersionNavigationButtonProps
> = ({ isLatestVersion, soldDate, isMobileDevice }) => {
  const router = useRouter();

  const getLink = () => {
    const env = getEnvironment();
    const baseUrl =
      env === Environments.DEV ? LOCAL_HOST_URL : process.env.VIRTUAL_DOMAIN;

    const url = new URL(`${baseUrl}${router.asPath}`);
    const params = new URLSearchParams(url.search);

    params.set(
      "filterDate",
      isLatestVersion ? soldDate : new Date().toISOString()
    );

    url.search = params.toString();
    return url.href;
  };

  const label = isLatestVersion ? "View Previous Version" : "View Updates";

  return (
    <>
      {isMobileDevice ? (
        <LinkButton
          px={0}
          variant="tertiary"
          text={label}
          css={`
            height: 19px;
            font-size: 14px;
            font-weight: 400;
            text-decoration: underline;
          `}
          href={getLink()}
          shouldOpenInNewWindow={false}
        />
      ) : (
        <LinkButton
          height={45}
          px={16}
          py={13}
          text={label}
          css={`
            white-space: nowrap;
          `}
          href={getLink()}
          shouldOpenInNewWindow={false}
        />
      )}
    </>
  );
};

export default VersionNavigationButton;
